import { Component, Input, OnInit, inject } from "@angular/core";
import { ForgeCardModule, ForgeDividerModule } from "@tylertech/forge-angular";
import { PacketService } from "@tylertech/packets-module";
import { ProcessViewModel } from "@tylertech/tyler-api-types";
import { ProcessingCardComponent } from "./processingCard.component";
import { CommonModule } from "@angular/common";

@Component({
    selector: "processes-component",
    imports: [
        CommonModule,
        ForgeCardModule,
        ForgeDividerModule,
        ProcessingCardComponent,
    ],
    templateUrl: "./processes.tmpl.html",
    styleUrls: [
        "./processes.component.scss"
    ],
})
export class ProcessesComponent implements OnInit
{
    private $packetService = inject(PacketService);

    @Input()
    enableLink: boolean;

    loading: boolean = true;

    list: ProcessViewModel[];

    ngOnInit(): void
    {
        this.$packetService.GetDashboardProcesses()
            .then((list: ProcessViewModel[]) =>
            {
                this.list = list;
            })
            .finally(() =>
            {
                this.loading = false;
            });
    }

    get hasData(): boolean
    {
        return this.list?.length > 0;
    }
}
